export default {
  IO (state, value) {
    if (!state.io) {
      state.io = value
    }
  },
  ENROLLED (state, value) {
    state.enrolled = value
  },
  ENROLLING (state, value) {
    state.enrolling = value
  },
  OFFLINE (state, value) {
    state.offline = value
  }
}
